module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main